
export default {
  name: 'IconCheckAll',
}
